import request from '@/utils/request'

export function login(data) {
  return request({
    url: '/auth-inner/authorization/login',
    method: 'post',
    data: data
  })
}

export function getInfo(data) {
  return request({
    url: '/merchant-api/mch/system/user',
    method: 'post',
    // url: '/merchant-api/merchantUser/user',
    // method: 'get',
    data: data
  })
}

export function logout() {
  return request({
    url: '/auth-inner/authorization/logout',
    method: 'post'
  })
}

// 用户设置信息接口
export function getMerchantInfo(params) {
  return request({
    url: '/merchant-api/mch/info',
    method: 'get',
    params
  })
}

export function checkDevice(data) {
  return request({
    url: '/auth/diffDevice',
    method: 'post',
    data: data
  })
}

export function sendDeviceVerifyCode(data) {
  return request({
    url: `/auth/deviceAuthCode`,
    method: 'post',
    data: data
  })
}

export function verifyDeviceEmailCode(data) {
  return request({
    url: `/auth/deviceAuthCodeSuccess`,
    method: 'post',
    data: data
  })
}

// 重置密码发送邮件
export function sendResetPwdEmail(data) {
  return request({
    url: `/merchant-api/forget/reset/sendResetPwdEmail`,
    method: 'post',
    data: data
  })
}

// 发送邮件验证码
export function sendSelfRegisterOtp(params) {
  return request({
    url: `/merchant-api/selfRegister/sendOtpCode`,
    method: 'post',
    data: params
  })
}

// Create merchant/account (self register) - frontend should encrypt params
export function createSelfRegister(params) {
  return request({
    url: `/merchant-api/selfRegister/create`,
    method: 'post',
    data: params
  })
}

// 修改密码
export function resetPwd(data) {
  return request({
    url: `merchant-api/forget/reset/resetPwd`,
    method: 'post',
    data: data,
    headers: {
      Authorization: data.token
    }
  })
}

// 验证修改密码的邮箱是否失效
export function isExpired(params) {
  return request({
    url: 'merchant-api/forget/reset/isExpired',
    method: 'get',
    params
  })
}
